module.exports = __webpack_public_path__ + "img/073651.d05df474.png";